/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_TitleInputs */



/**
* | output |
* | --- |
* | "Ledger" |
*
* @param {Promo_Ledger_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_title = /** @type {((inputs?: Promo_Ledger_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Registre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registro")
	return /** @type {LocalizedString} */ ("Ledger")
});